// Модальное окно добавление марки стали

// src/components/Directory/AddSteelGradeForm.js
import React, { useState, useRef, useEffect } from 'react'; // Добавлены useRef и useEffect
import {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CButton,
    CForm,
    CFormLabel,
    CFormInput,
    CRow,
    CCol,
    CInputGroup,
    CFormTextarea
} from '@coreui/react';
import { cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
// Импортируем модальное окно справочника нормативных документов
import NormDocumentsDirectory from '../NormDocuments/NormDocumentsDirectory'; // Проверьте путь

const AddSteelGradeForm = ({ visible, onClose, onSave }) => {
    const [steelGrade, setSteelGrade] = useState('');
    const [gostTu, setGostTu] = useState(''); // Это значение будет заполняться из справочника
    const [thickness, setThickness] = useState('');
    // Объединённое состояние для диапазона временного сопротивления
    const [tensileStrengthRange, setTensileStrengthRange] = useState('');
    const [minYieldStrength, setMinYieldStrength] = useState('');

    // Состояние для видимости модального окна справочника норм. документов
    const [isNormDocsModalVisible, setIsNormDocsModalVisible] = useState(false);

    // 1. useRef для доступа к DOM-элементу textarea
    const textareaRef = useRef(null);

    // 2. useEffect для автоувеличения textarea при изменении значения gostTu
    useEffect(() => {
        if (textareaRef.current) {
            // Сбрасываем высоту, чтобы scrollHeight был точным
            textareaRef.current.style.height = 'auto';
            // Устанавливаем новую высоту на основе scrollHeight
            // Ограничиваем максимальную высоту, например, 150px
            const newHeight = Math.min(textareaRef.current.scrollHeight, 150);
            textareaRef.current.style.height = `${newHeight}px`;
        }
    }, [gostTu]); // Зависимость от gostTu

    const handleSave = () => {
        // Базовая валидация
        if (!steelGrade) {
            alert('Пожалуйста, заполните обязательные поля (например, Марка стали).');
            return;
        }

        const newGradeData = {
            steelGrade,
            gostTu,
            thickness,
            // Отправляем объединённое значение как строку
            tensileStrengthRange,
            minYieldStrength: minYieldStrength ? parseFloat(minYieldStrength) : null,
        };

        onSave(newGradeData);

        // Сброс формы
        setSteelGrade('');
        setGostTu('');
        setThickness('');
        setTensileStrengthRange('');
        setMinYieldStrength('');
    };

    // Функция для открытия модального окна справочника норм. документов
    const handleAddGostTu = () => {
        setIsNormDocsModalVisible(true);
    };

    // Функция для закрытия модального окна справочника норм. документов
    const closeNormDocsModal = () => {
        setIsNormDocsModalVisible(false);
    };

    // Функция для обработки выбора документа из справочника
    const handleSelectDocument = (selectedDocument) => {
        console.log("Документ выбран в справочнике и передан в AddSteelGradeForm:", selectedDocument);
        // Устанавливаем значение поля gostTu равным имени выбранного документа
        setGostTu(selectedDocument.name); // Или другой формат, если нужно
        // Закрытие модального окна справочника
        closeNormDocsModal();
    };

    // Стили для ограничения размера модального окна
    const modalStyle = {
        maxHeight: '55vh',
        display: 'flex',
        flexDirection: 'column'
    };

    return (
        <>
            <CModal alignment="start" visible={visible} onClose={onClose} backdrop="static" size="lg" style={modalStyle}>
                <CModalHeader>
                    <CModalTitle>Добавить</CModalTitle>
                </CModalHeader>
                <CModalBody style={{ overflowY: 'auto', flex: '1 1 auto' }}>
                    <CForm>
                        <CRow className="mb-3">
                            <CCol md="5">
                                <CFormLabel>Марка стали</CFormLabel>
                            </CCol>
                            <CCol md="7">
                                <CFormInput
                                    type="text"
                                    value={steelGrade}
                                    onChange={(e) => setSteelGrade(e.target.value)}
                                    placeholder="Введите марку стали"
                                />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="5">
                                <CFormLabel>ГОСТ, ТУ</CFormLabel>
                            </CCol>
                            <CCol md="7">
                                <CInputGroup>
                                    {/* 3. Обновлённый CFormTextarea с автоувеличением */}
                                    <CFormTextarea
                                        // Передаём ref
                                        ref={textareaRef}
                                        value={gostTu}
                                        // Обработчик изменения для ручного ввода
                                        onChange={(e) => setGostTu(e.target.value)}
                                        placeholder="Выберите ГОСТ, ТУ"
                                        // Убираем фиксированное количество строк
                                        // rows={1}
                                        // Добавляем стили для автоувеличения и ограничений
                                        style={{
                                            minHeight: '38px', // Минимальная высота, как у кнопки
                                            height: 'auto',   // Начальная высота автоматическая
                                            resize: 'none',   // Запрещаем пользователю растягивать
                                            overflowY: 'hidden', // Скрываем скроллбар, если не нужен
                                            // maxHeight: '150px' // Максимальная высота (можно задать в CSS)
                                        }}
                                        // onInput для поддержки автоувеличения при ручном вводе
                                        onInput={(e) => {
                                            e.target.style.height = 'auto';
                                            const newHeight = Math.min(e.target.scrollHeight, 150);
                                            e.target.style.height = `${newHeight}px`;
                                        }}
                                    />
                                    <CButton
                                        type="button"
                                        color="primary"
                                        variant="outline"
                                        onClick={handleAddGostTu}
                                        style={{ maxHeight: '38px' }}
                                    >
                                        <CIcon icon={cilPlus} />
                                    </CButton>
                                </CInputGroup>
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="5">
                                <CFormLabel>Толщина проката, мм или разряд толщин</CFormLabel>
                            </CCol>
                            <CCol md="7">
                                <CFormInput
                                    type="text"
                                    value={thickness}
                                    onChange={(e) => setThickness(e.target.value)}
                                    placeholder="Введите толщину или разряд"
                                />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="5">
                                <CFormLabel>Минимальное и максимальное значение временного сопротивления стали, МПа</CFormLabel>
                            </CCol>
                            <CCol md="7">
                                <CFormInput
                                    type="text"
                                    value={tensileStrengthRange}
                                    onChange={(e) => setTensileStrengthRange(e.target.value)}
                                    placeholder="Например: 490-610"
                                />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="5">
                                <CFormLabel>Минимальный предел прочности, МПа</CFormLabel>
                            </CCol>
                            <CCol md="7">
                                <CFormInput
                                    type="number"
                                    value={minYieldStrength}
                                    onChange={(e) => setMinYieldStrength(e.target.value)}
                                    placeholder="Введите минимальный предел прочности"
                                    step="any"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={onClose}>
                        Отменить
                    </CButton>
                    <CButton color="primary" onClick={handleSave}>
                        Сохранить
                    </CButton>
                </CModalFooter>
            </CModal>

            {/* Добавляем модальное окно справочника нормативных документов */}
            <NormDocumentsDirectory
                visible={isNormDocsModalVisible}
                onClose={closeNormDocsModal}
                onSelect={handleSelectDocument} // Передаём функцию обработки выбора
            />
        </>
    );
};

export default AddSteelGradeForm;